import { render, staticRenderFns } from "./product_log.vue?vue&type=template&id=37586270&scoped=true&"
import script from "./product_log.vue?vue&type=script&lang=js&"
export * from "./product_log.vue?vue&type=script&lang=js&"
import style0 from "./product_log.vue?vue&type=style&index=0&id=37586270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37586270",
  null
  
)

export default component.exports